import { Box, styled } from '@mui/material';
import { forwardRef, ReactNode } from 'react';

interface WorkflowTabPanelProps {
  children: ReactNode;
  value: number;
  index: number;
  keepMounted?: boolean;
}

const PREFIX = 'WorkflowTabPanel';

const classes = {
  tabPanelHidden: `${PREFIX}-container`,
  tabPanelVisible: `${PREFIX}-header`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`& .${classes.tabPanelHidden}`]: {
    visibility: 'hidden',
  },
  [`& .${classes.tabPanelVisible}`]: {
    visibility: 'visible',
  },
}));

// Custom tab panel that can keep children mounted when hidden. This is necessary
// for the workflow edit form because it can be saved even when it is not focused.
const WorkflowTabPanel = forwardRef<HTMLDivElement, WorkflowTabPanelProps>(
  ({ children, value, index, keepMounted = false, ...props }, ref) => {
    const isActive = value === index;

    return (
      <StyledBox
        component="div"
        ref={ref}
        role="tabpanel"
        hidden={!isActive}
        className={isActive ? classes.tabPanelVisible : classes.tabPanelHidden}
        {...props}>
        {(isActive || keepMounted) && children}
      </StyledBox>
    );
  },
);

export default WorkflowTabPanel;
